import { pipe } from 'ramda';

import { IRootState } from '../../../store/root.types';

import { IProductState } from './product.reducer';

export const pathToProductState = (state: IRootState): IProductState => state.product;

export const getIsLoading = pipe(pathToProductState, state => state.isLoading);

export const getProduct = pipe(pathToProductState, state => state.product);
